
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon
    }
})
export default class FactumAppealBookAppRightToAppealPg extends Vue {

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void
    

    showFactumInfo = true;
    showRespondentFactumInfo = false;    
    showRespondentAppealBookCrossAppealInfo = false;
    showDisagreementOnContentsInfo = false;
    transcriptExtractBookHelpText = '<div>If a witness spoke at your original trial or hearing, and you mentioned this oral testimony in your Factum, you will need to complete a Transcript Extract Book.</div>';

    public showFactum(show: boolean){
        if (show) {
            this.showFactumInfo = true;
            this.$emit('adjustHeights', 0, "54.75rem");
        } else {
            this.showFactumInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showRespondentFactum(show: boolean){
        if (show) {
            this.showRespondentFactumInfo = true;
            this.$emit('adjustHeights', 1, "19rem");
        } else {
            this.showRespondentFactumInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showRespondentAppealBookCrossAppeal(show: boolean){
        if (show) {
            this.showRespondentAppealBookCrossAppealInfo = true;
            this.$emit('adjustHeights', 2, "4rem");
        } else {
            this.showRespondentAppealBookCrossAppealInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showDisagreementOnContents(show: boolean){
        if (show) {
            this.showDisagreementOnContentsInfo = true;
            this.$emit('adjustHeights', 2, "52rem");
        } else {
            this.showDisagreementOnContentsInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" });
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}
